var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shop-view"}},[_vm._v("\n    SHOP\n")])}
var staticRenderFns = []

export { render, staticRenderFns }